import React, { useCallback, useRef } from 'react';

import TasksList from './tasks-list';
import CreateTaskButton from './create-task-button';

const MilestoneOverviewGroup = ({ tasks, taskGroupId, milestoneId, draggedTaskId, onTaskClick, onTaskMove, onTaskDragStart, onTaskDragEnd, onCreateTask }) => {
    const handleTaskCreate = useCallback(name => {
        onCreateTask && onCreateTask(taskGroupId, name);
    }, [taskGroupId, onCreateTask]);

    return (
        <div className="overview-group">
            <div className="overview-group-list task-group">
                <TasksList
                    tasks={tasks}
                    groupId={taskGroupId}
                    milestoneId={milestoneId}
                    maxVisibleTasks={3}
                    simpleTask={true}
                    labelsFetched={true}
                    draggedTaskId={draggedTaskId}
                    onTaskClick={onTaskClick}
                    onTaskMove={onTaskMove}
                    onTaskDragStart={onTaskDragStart}
                    onTaskDragEnd={onTaskDragEnd}
                />

                {
                    onCreateTask ? (
                        <div className="group-foot tour-target-task-create">
                            <CreateTaskButton onCreateTask={handleTaskCreate} />
                        </div>
                    ) : null
                }
            </div>
        </div>
    );
}

export default MilestoneOverviewGroup;
